export class Pricing {
    constructor(pricing) {
        this.acquiring_offering_external_id = '';
        this.pricing_type = '';
        this.global_fee_table = '';
        this.settlement_method_id = '';
        this.transaction_items = '';
        this.service_charge_items = '';
        if (!!pricing) {
            this.setChargesData(pricing);
        }
    }

    setChargesData(pricing) {
        let pricing_keys = Object.keys(pricing);
        pricing_keys.map(f => {
            this[f] = !!pricing[f] ? pricing[f] : '';
        });
    }
}

export class BaseCharge {
    constructor(charge) {
        this.fee_perc = '';
        this.fee_base = '';
        this.min_fee = '';
        this.max_fee = '';
        if (!!charge) {
            this.setChargesData(charge);
        }
    }

    setChargesData(charge) {
        let charge_keys = Object.keys(charge);
        charge_keys.map(f => {
            if (f == 'transaction_items') {
                this[f] = new TransactionItem(charge[f]);
            } else if (f == 'service_charge_items') {
                this[f] = new ServiceItem(charge[f]);
            } else {
                this[f] = !!charge[f] ? charge[f] : '';
            }
        });
    }
}

export class TransactionItem extends BaseCharge {
    constructor(transactionItem) {
        super(transactionItem);
        this.transaction_charge_item_external_id = '';

        if (!!transactionItem) {
            this.setData(transactionItem);
        }
    }

    setData(transactionItem) {
        let transactionItem_keys = Object.keys(transactionItem);
        transactionItem_keys.map(f => {
            this[f] = transactionItem[f]
        });
    }
}

export class ServiceItem extends BaseCharge {
    constructor(serviceItem) {
        super(serviceItem);
        this.service_charge_item_external_id = '';

        if (!!serviceItem) {
            this.setData(serviceItem);
        }
    }

    setData(serviceItem) {
        let serviceItem_keys = Object.keys(serviceItem);
        serviceItem_keys.map(f => {
            this[f] = serviceItem[f]
        });
    }
}